import React from 'react';


export default
<g id="icon/upload/white" stroke="none" strokeWidth="1" fillRule="evenodd">
    <path d="M7.85725765,12.9413452 L12.1430102,12.9413452 L12.1430102,8.35307613 L15,8.35307613 L10.0001339,3 L5,8.35307613 L7.85725765,8.35307613 L7.85725765,12.9413452 Z M5,14.4706726 L15,14.4706726 L15,16 L5,16 L5,14.4706726 Z" id="Path_196"></path>
</g>;